export default __webpack_public_path__ + "img/hexagon.a159b199.svg";